export default __webpack_public_path__ + "static/media/icon-copied.720989a7.svg";